import React from 'react';
import { useCaeITGCCoverage } from '../../../hooks/analytics/useCaeReports.ts';
import { WidgetCard } from '../controller/shared.tsx';

/** Report #18 — ITGC Domain Coverage. Horizontal bars per domain: Total / Active / Passed. */
export const ITGCCoverageBars: React.FC = () => {
  const { data, isLoading, isError, error, dataUpdatedAt, isFetching, refetch } = useCaeITGCCoverage();
  const rows = data ?? [];
  const maxControls = Math.max(1, ...rows.map((r) => r.controls));

  return (
    <WidgetCard
      title="ITGC Domain Coverage"
      description="Controls tested vs. total per ITGC domain"
      loading={isLoading}
      error={isError ? error : null}
      errorMessage={error?.message ?? 'Failed to load ITGC domain coverage.'}
      isEmpty={!isLoading && !isError && rows.length === 0}
      emptyMessage="No ITGC domains configured."
      updatedAt={dataUpdatedAt}
      onRefresh={refetch}
      isFetching={isFetching}
    >
      <div className="analytics-scroll space-y-4 max-h-96 overflow-y-auto">
        {rows.map((row) => (
          <div key={row.code}>
            <div className="flex items-center justify-between text-sm mb-1">
              <span className="inline-flex items-center gap-2">
                <span className="inline-flex items-center rounded-full bg-gray-100 px-2 py-0.5 text-[10px] font-semibold text-gray-700">
                  {row.code}
                </span>
                <span className="font-medium text-gray-800">{row.name}</span>
              </span>
              <span className="text-xs text-gray-500">
                {row.passed} passed / {row.active} active / {row.controls} total
              </span>
            </div>
            <div className="w-full h-3 bg-gray-100 rounded-full overflow-hidden relative">
              <div
                className="h-full bg-blue-200 absolute left-0 top-0 rounded-full"
                style={{ width: `${(100 * row.controls) / maxControls}%` }}
              />
              <div
                className="h-full bg-blue-400 absolute left-0 top-0 rounded-full"
                style={{ width: `${(100 * row.active) / maxControls}%` }}
              />
              <div
                className="h-full bg-green-500 absolute left-0 top-0 rounded-full"
                style={{ width: `${(100 * row.passed) / maxControls}%` }}
              />
            </div>
          </div>
        ))}
      </div>
      {rows.length > 0 && (
        <div className="flex items-center gap-4 mt-4 pt-3 border-t border-gray-100 text-xs text-gray-500">
          <span className="inline-flex items-center gap-1.5">
            <span className="h-2.5 w-2.5 rounded-full bg-blue-200" /> Total
          </span>
          <span className="inline-flex items-center gap-1.5">
            <span className="h-2.5 w-2.5 rounded-full bg-blue-400" /> Active
          </span>
          <span className="inline-flex items-center gap-1.5">
            <span className="h-2.5 w-2.5 rounded-full bg-green-500" /> Passed
          </span>
        </div>
      )}
    </WidgetCard>
  );
};

export default ITGCCoverageBars;
